<template>
  <el-container style="height:100%">
    <!-- 移动端遮罩 -->
    <div v-if="isMobile && sidebarOpened" class="sidebar-overlay" @click="closeSidebar"></div>

    <el-aside :width="sidebarWidth" class="sidebar">
      <div class="logo">{{ isMobile ? '' : '后台管理' }}</div>
      <el-menu
        :default-active="activeMenu"
        router
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        :collapse="!sidebarOpened"
        :collapse-transition="false"
      >
        <template v-for="menu in menus">
          <el-submenu v-if="menu.children && menu.children.length" :key="menu.id" :index="menu.name">
            <template slot="title">
              <i :class="menu.icon"></i>
              <span>{{ menu.name }}</span>
            </template>
            <el-menu-item v-for="child in menu.children" :key="child.id" :index="child.path" @click="onMenuClick">
              <i :class="child.icon"></i>
              <span>{{ child.name }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :key="menu.id" :index="menu.path" @click="onMenuClick">
            <i :class="menu.icon"></i>
            <span>{{ menu.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="header">
        <div class="header-left">
          <i :class="sidebarOpened ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
             @click="toggleSidebar" class="toggle-btn"></i>
          <span class="header-title" v-if="isMobile">后台管理</span>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-name">管理员 <i class="el-icon-arrow-down"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="pwdDialogVisible" width="400px" @close="resetPwdForm" class="pwd-dialog">
      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="110px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" show-password placeholder="请输入原密码" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password placeholder="至少 6 位" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="pwdForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="pwdDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="handleChangePwd">确定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import { changePassword } from '@/api/auth'
export default {
  name: 'Layout',
  data() {
    return {
      mobile: false,
      pwdDialogVisible: false,
      pwdForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '新密码长度不能少于 6 位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, cb) => value === this.pwdForm.newPassword ? cb() : cb(new Error('两次输入的密码不一致')),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      menus: state => state.user.menus,
      sidebarOpened: state => state.app.sidebarOpened
    }),
    isMobile() { return this.mobile },
    sidebarWidth() {
      if (this.mobile) return '0px'
      return this.sidebarOpened ? '220px' : '64px'
    },
    activeMenu() { return this.$route.path }
  },
  mounted() {
    this.checkScreen()
    window.addEventListener('resize', this.checkScreen)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreen)
  },
  methods: {
    checkScreen() {
      this.mobile = window.innerWidth < 768
      if (this.mobile && this.sidebarOpened) {
        this.$store.commit('app/TOGGLE_SIDEBAR')
      }
    },
    toggleSidebar() { this.$store.commit('app/TOGGLE_SIDEBAR') },
    closeSidebar() { this.$store.commit('app/TOGGLE_SIDEBAR') },
    onMenuClick() {
      if (this.mobile) this.closeSidebar()
    },
    handleCommand(cmd) {
      if (cmd === 'password') {
        this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' }
        this.pwdDialogVisible = true
      } else if (cmd === 'logout') {
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
      }
    },
    handleChangePwd() {
      this.$refs.pwdForm.validate(valid => {
        if (!valid) return
        changePassword({
          oldPassword: this.pwdForm.oldPassword,
          newPassword: this.pwdForm.newPassword
        }).then(() => {
          this.pwdDialogVisible = false
          this.$message.success('密码修改成功，请重新登录')
          // 硬跳转清空内存中的动态路由
          window.location.href = '/login'
        }).catch(() => {})
      })
    },
    resetPwdForm() {
      this.$refs.pwdForm && this.$refs.pwdForm.resetFields()
    }
  }
}
</script>

<style scoped>
.sidebar {
  background: #304156;
  overflow-y: auto;
  transition: width 0.3s;
  position: relative;
  z-index: 10;
}

/* 移动端 sidebar 浮动覆盖 */
@media (max-width: 767px) {
  .sidebar {
    position: fixed !important;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    width: 220px !important;
  }
  .sidebar-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
  }
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  background: #2b2f3a;
  overflow: hidden;
  white-space: nowrap;
}

.header {
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  height: 60px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.toggle-btn {
  cursor: pointer;
  font-size: 20px;
  color: #606266;
}
.toggle-btn:hover { color: #409EFF; }

.header-right { cursor: pointer; }
.user-name { color: #606266; }

.main-content {
  background: #f0f2f5;
  padding: 15px;
}

/* 小屏减少内边距 */
@media (max-width: 767px) {
  .main-content {
    padding: 10px;
  }
}

/* 修改密码弹窗：表单 label 单行展示，不换行 */
.pwd-dialog ::v-deep .el-form-item__label {
  white-space: nowrap;
}
</style>
